import { Injectable } from '@angular/core';
@Injectable()
export class LoaderSpinnerService {
  displaySpinner = false;
  displayWrappedSpinner = false;
  displayCustomSpinner = false;
}
